import { defineMessages } from "@/i18n";
import type { PromptChipId } from "@/desktop/dictation-anywhere/prompt-chips";
import en from "./en";

export const settingsVoiceMessages = defineMessages("settings-voice", en);

type Key = keyof typeof en;

/** How Settings names each prompt chip. */
export const PROMPT_CHIP_LABEL_KEY = {
  "clean-up": "chipCleanUp",
  "make-concise": "chipMakeConcise",
  translate: "chipTranslate",
  "bullet-points": "chipBulletPoints",
  formal: "chipFormal",
} as const satisfies Record<PromptChipId, Key>;

/** Translate's languages by their English name, the one the prompt text uses. */
export const TRANSLATE_LANGUAGE_KEY: Readonly<
  Record<string, Extract<Key, `language${string}`>>
> = {
  English: "languageEnglish",
  German: "languageGerman",
  Spanish: "languageSpanish",
  French: "languageFrench",
  Chinese: "languageChinese",
  Japanese: "languageJapanese",
};

const MODEL_NAMES = {
  "whisper-base": { name: "modelWhisperBase", line: "modelWhisperBaseLine" },
  "parakeet-v3": { name: "modelParakeet", line: "modelParakeetLine" },
  "qwen3-asr": { name: "modelQwen3", line: "modelQwen3Line" },
  "x-asr-stream": {
    name: "modelEnglishStreaming",
    line: "modelEnglishStreamingLine",
  },
} as const satisfies Record<string, { name: Key; line: Key }>;

/** How Settings names each dictation model it knows, and what it is good
 *  for; a model a newer catalogue adds shows under its id until it has a
 *  name here. */
export const DICTATION_MODEL_NAME_KEY: Readonly<
  Record<string, (typeof MODEL_NAMES)[keyof typeof MODEL_NAMES] | undefined>
> = MODEL_NAMES;
